import React from 'react'
import {
  Button,
  Container,
  HtmlContent,
  Image,
  Popup,
  TextTitle
} from '@pdrj/pmi-iqos-ds-react'
import isMobile from 'ismobilejs'

const LotteryPopup = ({
  handleOnPopupClose,
  lotteryState,
  popupOpen,
  popups,
  states,
  translations
}) => {
  return (
    <Popup
      isOpen={popupOpen}
      onCloseHandler={handleOnPopupClose}
      fullScreen={false}
      data-testing-prefix={`LotteryState-${lotteryState}`}>
      <Container
        display={Container.displays.flex}
        flexDirection={Container.flexDirections.column}
        alignItems={Container.alignItemsValues.center}>
        <Container
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.column}
          alignItems={Container.alignItemsValues.center}
          justifyContent={
            isMobile().any
              ? Container.justifyContentValues.center
              : Container.justifyContentValues.between
          }>
          <Container pb="4">
            <TextTitle
              heading={TextTitle.headings.h4}
              alignment={TextTitle.alignments.center}>
              <HtmlContent
                content={
                  lotteryState === states.loose
                    ? popups?.lose?.title
                    : popups?.win?.title
                }
              />
            </TextTitle>
          </Container>
          <Container pt="4" pb="4">
            <HtmlContent
              content={
                lotteryState === states.loose
                  ? popups?.lose?.description
                  : popups?.win?.description
              }
              fullWidth
            />
          </Container>
          <Container pt="4">
            <Image
              src={
                lotteryState === states.loose
                  ? popups?.lose?.image
                  : popups?.win?.image
              }
            />
          </Container>
          <Container
            pt="8"
            flexDirection={Container.flexDirections.column}
            justifyContent={Container.justifyContentValues.center}>
            <Button
              text={translations.tk_popupButton}
              onClickHandler={handleOnPopupClose}
              data-testing="LotteryState_Button"
            />
          </Container>
        </Container>
      </Container>
    </Popup>
  )
}

export default LotteryPopup
